export const isNil = (x: any) => x == null
